import type { ReactNode } from 'react';

import { widgetTitleClassName } from '../../../edge/dashboard/_components/widgetChrome';

interface PortfolioSectionHeaderProps {
  actions?: ReactNode;
  bordered?: boolean;
  eyebrow?: ReactNode;
  subtitle?: ReactNode;
  title: ReactNode;
  titleAddon?: ReactNode;
  tone?: 'edge' | 'light';
}

export const PortfolioSectionHeader = ({
  actions,
  bordered = true,
  eyebrow,
  subtitle,
  title,
  titleAddon,
  tone = 'light',
}: PortfolioSectionHeaderProps) => {
  const isEdge = tone === 'edge';

  return (
    <div
      className={`flex shrink-0 flex-col gap-1 px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${
        bordered ? (isEdge ? 'border-b border-white/10' : 'border-b border-slate-200') : ''
      }`}
    >
      <div className="min-w-0">
        {eyebrow ? <div className="mb-1">{eyebrow}</div> : null}
        <div className="flex flex-wrap items-center gap-2">
          <h2 className={isEdge ? 'text-base font-extrabold tracking-tight text-white' : widgetTitleClassName}>
            {title}
          </h2>
          {titleAddon}
        </div>
        {subtitle ? (
          <p className={`mt-0.5 text-xs ${isEdge ? 'text-bzgray-400' : 'text-slate-500'}`}>{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  );
};
